import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/documents/page";

export const Route = createFileRoute("/clients/$clientId/dashboard/documents/")(
  {
    component: Page,
  },
);
